(function () {
    'use strict';
    var controllerId = 'cndTirCategAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'common', '_', 'datacontext', 'settore', 'partecipazioneId', 'apl', 'settProfess', 'numMaxTir', 'isSuper', cndTirCategAdd]);

    function cndTirCategAdd($scope, $uibModalInstance, common, _, datacontext, settore, partecipazioneId, apl, settProfess, numMaxTir, isSuper) {
        var getLogFn = common.logger.getLogFn;
        var logError = getLogFn(controllerId, 'logError');

        $scope.isSuper = isSuper;
        $scope.settProfess = settProfess;
        $scope.apl = apl;        
        $scope.SettProfessId = '';
        $scope.profiliProfess = [];
        $scope.bExist = false;
        $scope.numMaxTir = numMaxTir;

        if (settore) {
            $scope.record = jQuery.extend({}, settore);
            $scope.action = 'edit';
            $scope.title = 'Modifica ';
            $scope.SettProfessId = $scope.record.SettProfessId;
            geProfiliProfess($scope.record.SettProfessId);  
            existItem($scope.record.ProfiloProfessId);
        }
        else {
            $scope.record = {};
            $scope.action = 'add';
            $scope.title = 'Aggiungi ';
        }

        if (partecipazioneId) {
            $scope.partecipazioneId = partecipazioneId;
            $scope.record.PartecipazioneId = partecipazioneId;
        }

        $scope.geProfiliProfess = geProfiliProfess;
        function geProfiliProfess(id) {
            $scope.profiliProfess = [];
            if (!id || id == null || typeof id == "undefined") return;
            return datacontext.profiloProfess_getAllList('', id, 0).then(function (data) {
                return $scope.profiliProfess = data;
            });
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = toDoItem($scope.record);
                result.then(function (data) {
                    if (typeof data != 'undefined' && !$.isNumeric(data)) {
                        $uibModalInstance.close(result);
                    }
                });
            }
        };

        function toDoItem(item) {
            switch ($scope.action) {
                case 'add':
                    return addItem(item);
                case 'edit':
                    return editItem(item);
            }
        }

        function addItem(item) {
            return datacontext.pTirCateg_add(item).then(function (data) {
                if (data == "300") {
                    logError('Attenzione: inserire prima il numero totale di tirocini. ');
                }
                else if (data == "406") {
                    logError('Attenzione: il numero totale di tirocini \xE8 "' + $scope.numMaxTir + '". Verificare il numero inserito. ');
                }

                return data;
            });
        }

        function editItem(item) {
            return datacontext.pTirCateg_merge(item).then(function (data) {
                if (data == "300") {
                    logError('Attenzione: inserire prima il numero totale di tirocini. ');
                }
                else if (data == "406") {
                    logError('Attenzione: il numero totale di tirocini \xE8 "' + $scope.numMaxTir + '". Verificare il numero inserito. ');
                }

                return data;
            });
        }

        $scope.exist = existItem;
        function existItem(profiloProfessId) {
            $scope.bExist = false;
            if (typeof profiloProfessId == 'undefined' || !profiloProfessId || profiloProfessId == 0)
                return;
            $scope.bExist = true;
            return datacontext.pTirCateg_exist($scope.record.APLId, $scope.record.Id, profiloProfessId).then(function (data) {
                return $scope.bExist = data;
            });
        }
    }
})();